<script>

export default {
    name: 'dkbr-input',
    txtDescr: 'Input. Emit the "edited" event on change with the new value. Property "value" should be updated manually outside. If type of the field is Boolean and it is not Enabled/Editable, then checkbox is used, the switch is used otherwise (use "isCheckBox" and "isSwitch" props to change it)',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        value: {
            name: 'value',
            txtDescr: `Initial value for input`,
            default: _ => undefined,
        },
        name: {
            name: 'name',
            type: String,
            txtDescr: `Title for input field`,
            default: _ => 'Option',
        },
        type: {
            name: 'type',
            type: String,
            enum: ['boolean', 'number', 'string', 'array'],
            txtDescr: `Type of the value (';' delimiter should be used for array type without enum)`,
            default: _ => 'string',
        },
        enum: {
            name: 'enum',
            type: Array,
            txtDescr: `A list of possible options for the value`,
            txtEnable: `Is not enabled for boolean`,
            default: _ => undefined,
            enabled: (v, sett) => sett.type != 'boolean',
        },
        txtDescr: {
            name: 'txtDescr',
            type: String,
            txtDescr: `Description of the value`,
            default: _ => '',
        },
        txtEditable: {
            name: 'txtEditable',
            type: String,
            txtDescr: `Explanation why value is not editable`,
            default: _ => '',
        },
        txtEnable: {
            name: 'txtEnable',
            type: String,
            txtDescr: `Explanation why value is not enabled`,
            default: _ => '',
        },
        txtError: {
            name: 'txtError',
            type: String,
            txtDescr: `String representation of an error for the current value`,
            default: _ => '',
        },
        lengthMax: {
            name: 'lengthMax',
            type: Number,
            txtDescr: `Maximum length of the input text`,
            txtEnable: `Is not enabled for boolean and array or if enum is set`,
            txtError: `It should be non negative number`,
            enabled: (v, sett) =>
                (!sett.enum || !sett.enum.length) &&
                sett.type != 'boolean' && sett.type != 'array',
            validator: (v, sett) => v >= 0,
            default: _ => 0,
        },
        lengthShortMax: {
            name: 'lengthShortMax',
            type: Number,
            txtDescr: `If text is longer, input will be shown as textarea`,
            txtEnable: `Is not enabled for boolean and array or if enum is set`,
            txtError: `It should be non negative number`,
            enabled: (v, sett) =>
                (!sett.enum || !sett.enum.length) &&
                sett.type != 'boolean' && sett.type != 'array',
            validator: (v, sett) => v >= 0,
            default: _ => 50,
        },
        tooltipDir: {
            name: 'tooltipDir',
            type: String,
            enum: ['top', 'right', 'bottom', 'left', 'none'],
            txtDescr: `Direction of the tooltip`,
            default: _ => 'right',
        },
        isRequired: {
            name: 'isRequired',
            type: Boolean,
            txtDescr: `If true, input will be shown as 'required'`,
            default: _ => false,
        },
        isEditable: {
            name: 'isEditable',
            type: Boolean,
            txtDescr: `If false, input will be read only`,
            default: _ => true,
        },
        isEnabled: {
            name: 'isEnabled',
            type: Boolean,
            txtDescr: `If false, input will be shown in deactivated mode`,
            default: _ => true,
        },
        isPassword: {
            name: 'isPassword',
            type: Boolean,
            txtDescr: `If true, input will be shown as a password (stars)`,
            txtEnable: `Is not enabled for boolean type or if enum is set`,
            enabled: (v, sett) =>
                (!sett.enum || !sett.enum.length) &&
                sett.type != 'boolean' && sett.type != 'array',
            default: _ => false,
        },
        isCheckBox: {
            name: 'isCheckBox',
            type: Boolean,
            txtDescr: `If is true, then checkbox will be always used for Boolean`,
            txtEnable: `Is may be applied only for Boolean`,
            enabled: (v, sett) => sett.type == 'boolean',
            default: _ => false,
        },
        isSwitch: {
            name: 'isSwitch',
            type: Boolean,
            txtDescr: `If is true, then switch will be always used for Boolean`,
            txtEnable: `Is may be applied only for Boolean and if not isCheckBox`,
            enabled: (v, sett) => sett.type == 'boolean' && !sett.isCheckBox,
            default: _ => false,
        },
    },
    data() {
        return {
            value_: this.valueParse(this.value)
        }
    },
    computed: {
        length() {
            return this.value_.toString().length
        },
        displayIn() {
            if(this.type == 'boolean' && this.isCheckBox)
                return 'checkbox'
            if(this.type == 'boolean' && this.isSwitch)
                return 'switch'
            if(this.type == 'boolean' && !this.isEditable)
                return 'checkbox'
            if(this.type == 'boolean' &&  this.isEditable)
                return 'switch'
            if(this.enum && this.enum.length)
                return 'select'
            if(this.length <= this.lengthShortMax)
                return 'input'
            if(this.isPassword)
                return 'input'
            if(this.type == 'number')
                return 'input'
            return 'textarea'
        },
        descrFull() {
            let s = this.txtDescr
            if(!this.isEditable && this.txtEditable)
                s+= '. ' + this.txtEditable
            if(!this.isEnabled && this.txtEnable)
                s+= '. ' + this.txtEnable
            return s
        },
    },
    watch: {
        value(valueNew) {
            this.value_ = this.valueParse(valueNew)
        },
        value_(valueNew) { // is used only due to bug in 'select' component
            console.log('value_', this.value_, this.enum, this.valueParse(this.value_))
            if(this.displayIn == 'select')
                this.edited()
        },
    },
    methods: {
        valueParse(value) {
            if(this.type == 'boolean')
                return Boolean(value)
            if(this.type == 'number')
                return Number(value)
            if(this.type == 'string')
                return value ? String(value) : ''
            if(this.type == 'array' && this.enum) {
                if(value === undefined)
                    return []
                if(Array.isArray(value))
                    return value
                else
                    return value.split(';')
            }
            if(this.type == 'array' && !this.enum) {
                if(value === undefined)
                    return ''
                if(Array.isArray(value))
                    return value.join(';')
                else
                    return value ? value.split(';') : []
            }
            throw `Incorrect value type ("type" prop)`
        },
        edited(v) {
            console.log('edited', this.value_, this.enum, this.valueParse(this.value_), v)
            this.$emit('edited', this.valueParse(this.value_))
        },
    },
}
</script>

<template lang="pug">

div.dkbr-input
    dkbr-tooltip(
        v-if="descrFull"
        :text="descrFull"
        :dir="tooltipDir"
        :dt="100")
    md-switch(
        v-if="displayIn == 'switch'"
        v-model="value_"
        :md-theme="isThInv ? th+'i' : th"
        :class=`['md-primary']`
        :name="name"
        :disabled="!isEnabled || !isEditable"
        @change="edited") {{ name }}
    md-checkbox(
        v-if="displayIn == 'checkbox'"
        v-model="value_"
        :md-theme="isThInv ? th+'i' : th"
        :class=`['md-primary']`
        :name="name"
        :disabled="!isEnabled || !isEditable"
        @change="edited") {{ name }}
    md-field(
        v-if="['select', 'input', 'textarea'].indexOf(displayIn) >= 0"
        :md-theme="isThInv ? th+'i' : th"
        :class=`['md-primary', {'md-invalid': txtError}]`
        :md-has-password="isPassword")
        label {{ name }}
        md-select(
            v-if="displayIn == 'select'"
            v-model="value_"
            :md-theme="isThInv ? th+'i' : th"
            :class=`['md-primary', {'md-invalid': txtError}]`
            :multiple="type == 'array'"
            :disabled="!isEnabled || !isEditable"
            :required="isRequired"
            @change="edited")
            md-option(
                v-for="(item, i) of this.enum"
                :key="i"
                :disabled="false"
                :value="item") {{ item }}
        md-input(
            v-if="displayIn == 'input'"
            v-model="value_"
            :md-theme="isThInv ? th+'i' : th"
            :class=`['md-primary', {'md-invalid': txtError}]`
            :placeholder="name"
            :type="isPassword? 'password' : type=='number' ? 'number' : null"
            :maxlength="lengthMax>0 ? lengthMax : undefined"
            :disabled="!isEnabled"
            :readonly="!isEditable"
            :required="isRequired"
            @blur="edited"
            @keyup.enter="edited")
        md-textarea(
            v-if="displayIn == 'textarea'"
            v-model="value_"
            :md-theme="isThInv ? th+'i' : th"
            :class=`['md-primary', {'md-invalid': txtError}]`
            :placeholder="name"
            :maxlength="lengthMax>0 ? lengthMax : undefined"
            :disabled="!isEnabled"
            :readonly="!isEditable"
            :required="isRequired"
            @change="edited")
        //<span class="md-helper-text">Helper text</span>
        span.md-error {{ txtError }}
</template>

<style lang="sass">

.dkbr-input
</style>



// WEBPACK FOOTER //
// src/input/vue/Input.vue